/**
 * @desc: 肖恩助手入口
 * */

import React from 'react';
import PropTypes from 'prop-types';
import './entry.scss';
import './mobile-entry.scss';
import Draggable from 'react-draggable';
import NewMessageAudio from '@/components/NewMessageAudio';
import MobileEntry from '@/components/entry/components/Mobile';
import ImSuspension from '@/components/ImSuspension';

// 用户行为  点击 - click 拖拽 - drag
let userBehaviour = 'click';

export default class Entry extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dragMoving: false,
      entryPosition: null,
    };
  }

  static propTypes = {
    data: PropTypes.shape({
      online: PropTypes.bool,
      newMessageCount: PropTypes.number,
      isMobile: PropTypes.bool,
      // 自定义 entry, 入参： isMobile, newMessageCount, online，如果返回为 Null 则会使用默认的
      renderCustomEntry: PropTypes.func,
      customEntryStyle: PropTypes.object,
    }),
    marvin: PropTypes.shape({
      // 班主任头像
      avatar: PropTypes.string,
      name: PropTypes.string,

    }),
    opening: PropTypes.bool,
    $openDialog: PropTypes.func,
    $closeDialog: PropTypes.func,
  };

  getPcEntryElementProps = () => {
    const { data, opening, marvin } = this.props;
    return {
      onClick: this.openDialog,
      newMessageCount: data && data.newMessageCount,
      online: data && data.online,
      opening,
      // 班主任头像
      avatar: marvin && marvin.avatar,
      name: marvin && marvin.name,
    };
  };

  getMobileEntryElementProps = () => ({
    ...this.getPcEntryElementProps(),
    onClick: this.toggleDialog,
  });

  renderPcEntryElement = () => {
    const { data } = this.props;
    let customElement = null;
    const entryProps = this.getPcEntryElementProps();
    const { dragMoving, entryPosition } = this.state;
    if (data.renderCustomEntry) {
      customElement = data.renderCustomEntry(entryProps);
    }

    const imPositionStyle = data.customEntryStyle || {
      right: 24, bottom: 24,
    };

    return (
      <>
        <Draggable onDrag={this.dragMove} onStop={this.dragStop} position={entryPosition}>
          {
            // customElement || <PcEntry {...entryProps} />
            customElement || <ImSuspension {...entryProps} style={imPositionStyle} dragMoving={dragMoving} />
          }
        </Draggable>
        <NewMessageAudio autoplay={!!entryProps.newMessageCount} />
      </>
    );
  };

  renderMobileEntryElement = () => {
    const entryProps = this.getMobileEntryElementProps();
    // 移动端的 IM 入口比较奇葩，暂时不增加自定义功能
    return (
      <>
        <MobileEntry {...entryProps} />
        <NewMessageAudio autoplay={!!entryProps.newMessageCount} />
      </>
    );
  };

  // 打开对话框
  openDialog = () => {
    if (userBehaviour === 'click') {
      this.props.$openDialog();
    } else {
      userBehaviour = 'click';
    }
  };

  toggleDialog = () => {
    this.props.opening ? this.props.$closeDialog() : this.props.$openDialog();
  };

  // 拖拽中
  dragMove = () => {
    userBehaviour = 'drag';
    this.setState({
      dragMoving: true,
    });
  }

  // 拖拽结束
  dragStop = (e) => {
    // 拖动超出可视区域 重置 IM入口 位置
    let entryPosition = null;
    const imSuspension = document.querySelector('.im-suspension');
    const { left, top, bottom, right, width, height } = imSuspension.getBoundingClientRect();
    // IM入口按钮 在可视区域的可视高宽临界值
    const critical = 10;
    if (
      top + height < critical
      || left + width < critical
      || window.innerWidth - left < critical
      || window.innerHeight - top < critical
    ) {
      entryPosition = { x: 0, y: 0 };
    }
    this.setState({
      dragMoving: false,
      entryPosition,
    });
  }

  render() {
    const { data } = this.props;

    return data.isMobile
      ? this.renderMobileEntryElement()
      : (
        this.renderPcEntryElement()
      );
  }
}
